// extracted by mini-css-extract-plugin
module.exports = {"root":"customLinkPreview_root__zgzrH","linkNotFound":"customLinkPreview_linkNotFound__2EcG2","linkPreview":"customLinkPreview_linkPreview__2TU0s"};